import React from 'react';

export const ChevronDownIcon = ({ className = "w-4 h-4" }: { className?: string }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
